new WOW().init();

window.addEventListener('scroll', function () {
    const element = document.querySelector('.template-index');
    if (window.scrollY > 950) {
        element.classList.add('scrolled');
    } else {
        element.classList.remove('scrolled');
    }
});

$(document).ready(function ($) {
    $('.hero__marquee-wrapper').slick({
        speed: 15000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
});

const image = document.querySelector('.hero__logo');

let latestScrollY = 0;
let ticking = false;

function onScroll() {
    latestScrollY = window.scrollY;
    requestTick();
}

function requestTick() {
    if (!ticking) {
        requestAnimationFrame(updateImagePosition);
        ticking = true;
    }
}

function updateImagePosition() {
    const translateY = latestScrollY * 0.5; // Adjust 0.5 to control speed
    image.style.transform = `translateY(-${translateY}px)`;
    ticking = false;
}

window.addEventListener('scroll', onScroll);
